
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export const DrawerContext = createContext<{
  onClose: () => void;
  setOnClose: (fn: () => void) => void;
  onConfirmLeave: () => void;
  setOnConfirmLeave: (fn: () => void) => void;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}>({
  onClose: () => { },
  setOnClose: () => { },
  onConfirmLeave: () => { },
  setOnConfirmLeave: () => { },
  setIsModalOpen: () => { },
});

export const useDrawer = () => useContext(DrawerContext);